export default __webpack_public_path__ + "static/media/success-ribbons.9eb3116a.svg";